export default __webpack_public_path__ + "static/media/misc-icon.d7661014.png";